// src/components/JungleBackground.js

import React, { Suspense, useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';

function JungleModel() {
  const modelRef = useRef();
  const { scene } = useGLTF('/jungle.glb');

  useFrame(() => {
    if (modelRef.current) {
      modelRef.current.rotation.y += 0.0002;
    }
  });

  return (
    <group ref={modelRef}>
      {/* 
        We are resetting the model's position to the center (0,0,0).
        It's easier to move the camera around a centered object.
        You can adjust the scale here if needed.
      */}
      <primitive 
        object={scene} 
        scale={1000}
        position={[0, 0, 0]} 
      />
    </group>
  );
}

export default function JungleBackground() {
  return (
    <Canvas 
      className="jungle-background-canvas"

      // --- THIS IS THE KEY FIX: A ROBUST CAMERA SETUP FOR A LARGE SCENE ---
      camera={{ 
        position: [0, 10, 50],  // Move the camera WAY back (z=50) and slightly up (y=10)
        fov: 45,               // A more natural field of view, less distortion
        near: 0.1,             // Don't render things too close
        far: 1000              // Render things very far away (important for large scenes)
      }}
    >
      {/* Lights are adjusted to better illuminate a larger scene */}
      <ambientLight intensity={1.2} color="#a3b18a" />
      <directionalLight 
        position={[10, 20, 5]} 
        intensity={2} 
        color="#ffffff" 
      />
      <Suspense fallback={null}>
        <JungleModel />
      </Suspense>
    </Canvas>
  );
}